import { WdprBadge } from "components/vista";
import React from "react";

const Message = ({
	label,
	content,
	animationClasses,
	containerStyle,
	isTxp,
}) => {
	const mainClass = "syndicated-section__content__message";
	return (
		<div
			className={`${mainClass} ${animationClasses ?? ""}`}
			style={containerStyle}
		>
			{isTxp ? (
				<div className={`${mainClass}__title`}>
					<WdprBadge label={label} variant={"error"} />
				</div>
			) : (
				<p className={`${mainClass}__title`}>{label}</p>
			)}

			<p
				className={`${mainClass}__content`}
				dangerouslySetInnerHTML={{
					__html: content,
				}}
			/>
		</div>
	);
};

export default Message;
